import { useQuery } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';
import { checkValidCatalogProductId, queryOptions } from '@domains/pdp-common';

import { getPdpShopStory } from '../graphql/shop-story.2';

export function getShopStoryQueryOption(shop_id: string, options?: GqlRequestOptions) {
  return {
    queryKey: ['getPdpShopStory'],
    queryFn: async function () {
      const { data } = await getPdpShopStory({ shop_id }, { ...options, show_alert: false });
      return data?.has_story;
    },
    ...queryOptions,
    enabled: checkValidCatalogProductId(shop_id),
  };
}

export function useGetShopStoryQuery(shop_id: string, enabled: boolean) {
  const DEFAULT_DATA = {
    has_story: false,
    is_new: false,
  };

  const response = useQuery(
    Object.assign(getShopStoryQueryOption(shop_id), {
      enabled,
    }),
  );

  return {
    ...response,
    has_story: response.error || !response.data ? DEFAULT_DATA : response.data,
  };
}
